import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  root: {
    display: "flex"
    // alignItems: "center"
  },
  header: {
    display: "flex"
  },
  title: {
    display: "flex",
    marginRight: 4,
    fontSize: 16,
    [theme.breakpoints.up("md")]: {
      marginBottom: 8,
      fontSize: 20
    }
  },
  scheduling: {
    [theme.breakpoints.up("md")]: {
      marginBottom: 8,
      fontSize: 13
    }
  },
  normalLine: {
    lineHeight: "normal"
  },
  dates: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  datesRange: {
    [theme.breakpoints.up("md")]: {
      marginBottom: 8,
      fontSize: 14
    }
  },
  primary600: {
    color: theme.palette.primary.dark
  },
  schedule: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
  },
  dayNames: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    flexGrow: 1,
    transform: "translateZ(0)",
    overflow: "hidden"
  },
  day: {
    textAlign: "center",
    color: theme.palette.primary.dark,
    width: "13%",
    height: "auto",
    borderRadius: 2,
    minWidth: "13%",
    maxWidth: "13%",
    marginTop: 10,
    lineHeight: 1,
    marginRight: "calc(100% / 7 - 13%)",
    "&:nth-child(7n)": {
      marginRight: 0
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 12
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 14
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 16
    }
  },

  facilityName: {
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      marginRight: -8
    },
    "& .MuiSvgIcon-root": {
      [theme.breakpoints.down("xs")]: {
        marginLeft: 0,
        marginRight: -8
      }
    },
    "& .MuiButton-label": {
      [theme.breakpoints.down("xs")]: {
        lineHeight: 1
      }
    }
  }
}));
